import * as actions from "../../../../Actions/MyDataActions";
import * as verbs from "../../../../Actions/VerbiageActions";
import { CompanyType } from "../../../../Enums/CompanyType";

const _headerCell = (column) => {
    return {
        onClick: () => {
            actions.updateSortOrder(column);
        },
    };
};

export const storeColumns = (companyType: CompanyType) => {
    const salesTitleTranslated = verbs.getSalesWord(companyType, true);
    
    const storeCols = [
        {
            title: "Location ID",
            dataIndex: "id",
            width: 200,
            type: "i",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Type ID",
            dataIndex: "storeTypeID",
            width: 200,
            type: "i",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Name",
            dataIndex: "name",
            width: 200,
            type: "s",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Location #",
            dataIndex: "storeNumber",
            width: 200,
            type: "s",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Address 1",
            dataIndex: "address.address1",
            width: 200,
            type: "s",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Address 2",
            dataIndex: "address.address2",
            width: 200,
            type: "s",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Address 3",
            dataIndex: "address.address3",
            width: 200,
            type: "s",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "City",
            dataIndex: "address.city",
            width: 200,
            type: "s",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "State",
            dataIndex: "address.state",
            width: 200,
            type: "s",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Zip",
            dataIndex: "address.zip",
            width: 200,
            type: "s",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Zip +4",
            dataIndex: "address.zip4",
            width: 200,
            type: "s",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Opened",
            dataIndex: "openDate",
            width: 200,
            type: "d",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Closed",
            dataIndex: "closeDate",
            width: 200,
            type: "d",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: salesTitleTranslated,
            dataIndex: "actualSales",
            width: 200,
            type: "i",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Region Code",
            dataIndex: "regionCode",
            width: 200,
            type: "s",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "BUDS",
            dataIndex: "buds",
            width: 200,
            type: "i",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Country",
            dataIndex: "address.country",
            width: 200,
            type: "s",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "SQFT",
            dataIndex: "squareFeet",
            width: 200,
            type: "i",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Trade Area Overall",
            dataIndex: "tradeAreaOverall",
            width: 200,
            type: "i",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Volume",
            dataIndex: "actualVolume",
            width: 200,
            type: "i",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Latitude",
            dataIndex: "latitude",
            width: 200,
            type: "i",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Longitude",
            dataIndex: "longitude",
            width: 200,
            type: "i",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Website",
            dataIndex: "website",
            width: 200,
            type: "s",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Phone",
            dataIndex: "phone",
            width: 200,
            type: "s",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Fax",
            dataIndex: "fax",
            width: 200,
            type: "s",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Email",
            dataIndex: "email",
            width: 200,
            type: "s",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Target Sales",
            dataIndex: "targetSales",
            width: 200,
            type: "i",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Employee Count",
            dataIndex: "employeeCount",
            width: 200,
            type: "i",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Manager Count",
            dataIndex: "managerCount",
            width: 200,
            type: "i",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Sales Margin",
            dataIndex: "salesMargin",
            width: 200,
            type: "i",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Comments",
            dataIndex: "comments",
            width: 200,
            type: "s",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
        {
            title: "Proforma Sales",
            dataIndex: "proformaSales",
            type: "i",
            sorter: true,
            isChecked: true,
            onHeaderCell: _headerCell,
        },
    ];

    return storeCols;
};

export const pushpinColumns = [
    {
        title: "Name",
        dataIndex: "name",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.name).localeCompare(b.name),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Address 1",
        dataIndex: "address.address1",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.address.address1).localeCompare(b.address.address1),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Address 2",
        dataIndex: "address.address2",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.address.address2).localeCompare(b.address.address2),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Address 3",
        dataIndex: "address.address3",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.address.address3).localeCompare(b.address.address3),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "City",
        dataIndex: "address.city",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.address.city).localeCompare(b.address.city),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "State",
        dataIndex: "address.state",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.address.state).localeCompare(b.address.state),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Zip",
        dataIndex: "address.zip",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.address.zip).localeCompare(b.address.zip),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Zip +4",
        dataIndex: "address.zip4",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.address.zip4).localeCompare(b.address.zip4),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Country",
        dataIndex: "address.country",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.address.country).localeCompare(b.address.country),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Phone",
        dataIndex: "phone",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.phone).localeCompare(b.phone),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Fax",
        dataIndex: "fax",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.fax).localeCompare(b.fax),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Website",
        dataIndex: "website",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.website).localeCompare(b.website),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Latitude",
        dataIndex: "latitude",
        width: 200,
        type: "i",
        //sorter: (a, b) => a.latitude - b.latitude,
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Longitude",
        dataIndex: "longitude",
        width: 200,
        type: "i",
        //sorter: (a, b) => a.longitude - b.longitude,
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Created Date",
        dataIndex: "createdDate",
        width: 200,
        type: "d",
        //sorter: (a, b) => (a.createdDate).localeCompare(b.createdDate),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Modified Date",
        dataIndex: "modifiedDate",
        width: 200,
        type: "d",
        //sorter: (a, b) => (a.modifiedDate).localeCompare(b.modifiedDate),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Comments",
        dataIndex: "comments",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.comments).localeCompare(b.comments),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Type ID",
        dataIndex: "typeID",
        type: "i",
        isChecked: true,
    },
];

export const territoryColumns = [
    {
        title: "Name",
        dataIndex: "name",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.name).localeCompare(b.name),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Display Label",
        dataIndex: "displayLabel",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.displayLabel).localeCompare(b.displayLabel),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Data Value",
        dataIndex: "dataValue",
        width: 200,
        type: "i",
        //sorter: (a, b) => a.dataValue - b.dataValue,
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    /*{
    title: 'Latitude',
    dataIndex: 'latitude',
    width: 200,
    type: "i",
    sorter: (a, b) => a.latitude - b.latitude,
    isChecked: true,
}, {
    title: 'Longitude',
    dataIndex: 'longitude',
    width: 200,
    type: "i",
    sorter: (a, b) => a.longitude - b.longitude,
    isChecked: true,
},*/ {
        title: "Created Date",
        dataIndex: "createdDateTimeFriendly",
        width: 200,
        type: "d",
        //sorter: (a, b) => (a.createdDateTimeFriendly).localeCompare(b.createdDateTimeFriendly),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Franchise Name",
        dataIndex: "franchiseName",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.franchiseName).localeCompare(b.franchiseName),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Franchise Phone",
        dataIndex: "franchisePhone",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.franchisePhone).localeCompare(b.franchisePhone),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Franchise Email",
        dataIndex: "franchiseEmail",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.franchiseEmail).localeCompare(b.franchiseEmail),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Franchise Title",
        dataIndex: "franchiseTitle",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.franchiseTitle).localeCompare(b.franchiseTitle),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Franchise Unique ID",
        dataIndex: "franchiseUniqueID",
        width: 200,
        type: "s",
        //sorter: (a, b) => (a.franchiseUniqueID).localeCompare(b.franchiseUniqueID),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Franchise Units Purchased",
        dataIndex: "franchiseUnitsPurchased",
        width: 200,
        type: "i",
        //sorter: (a, b) => a.franchiseUnitsPurchased - b.franchiseUnitsPurchased,
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Franchise Units Opened",
        dataIndex: "franchiseUnitsOpened",
        width: 200,
        type: "i",
        //sorter: (a, b) => a.franchiseUnitsOpened - b.franchiseUnitsOpened,
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Franchise Purchase Amount",
        dataIndex: "franchisePurchaseAmount",
        width: 200,
        type: "i",
        //sorter: (a, b) => a.franchisePurchaseAmount - b.franchisePurchaseAmount,
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Type ID",
        dataIndex: "typeID",
        width: 200,
        type: "i",
        isChecked: true,
    },
    {
        title: "Modified Date",
        dataIndex: "modifiedDateTimeFriendly",
        type: "d",
        //sorter: (a, b) => (a.modifiedDateTimeFriendly).localeCompare(b.modifiedDateTimeFriendly),
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
];

export const targetMarketColumns = [
    {
        title: "Developer",
        dataIndex: "userName",
        width: 200,
        type: "s",
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Brand",
        dataIndex: "typeName",
        width: 200,
        type: "s",
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Target Name",
        dataIndex: "locationName",
        width: 200,
        type: "s",
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Sub-Market",
        dataIndex: "submarket",
        width: 200,
        type: "s",
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Address",
        dataIndex: "address",
        width: 250,
        type: "s",
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "City",
        dataIndex: "city",
        width: 150,
        type: "s",
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "State",
        dataIndex: "state",
        width: 100,
        type: "s",
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Zip Code",
        dataIndex: "zipcode",
        width: 100,
        type: "s",
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Country",
        dataIndex: "country",
        width: 150,
        type: "s",
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Room Count",
        dataIndex: "roomCount",
        width: 150,
        type: "i",
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "Comment",
        dataIndex: "comments",
        width: 300,
        type: "s",
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "STR Market Name",
        dataIndex: "strMarketName",
        width: 200,
        type: "s",
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
    {
        title: "STR Tract Name",
        dataIndex: "strTractName",
        width: 200,
        type: "s",
        sorter: true,
        isChecked: true,
        onHeaderCell: _headerCell,
    },
];
